// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__2A7dH","createdSearch":"index_createdSearch__VHf8E","custom_table":"index_custom_table__ysiek"};